import { Form, Input, Select } from 'antd';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';
import { ADYEN_GENDER_INVOICING } from 'app/typings/hotels/Finance/Finance';
import { emailAsciiRule } from 'app/utils/rules';

import { RULES, formatGender } from '../utils';

const { Option } = Select;

type InvoicingContactSectionProps = {
  isEditMode: boolean;
  hotelId: number;
};

export const InvoicingContactSection = ({
  isEditMode,
  hotelId,
}: InvoicingContactSectionProps) => {
  const { data: hotel } = useGetHotel(hotelId);

  const gender = formatGender(hotel?.finance?.invoicing.gender);

  const fullContact = `${gender} ${hotel?.finance?.invoicing.firstName || ''} ${
    hotel?.finance?.invoicing.lastName || ''
  }`.trim();

  if (!isEditMode) {
    return (
      <>
        <FormLineLayout label="Contact">
          <span>{fullContact || 'No contact information'}</span>
        </FormLineLayout>
        <FormLineLayout label="Email">
          <span>{hotel?.finance?.invoicing.email || 'No email'}</span>
        </FormLineLayout>
      </>
    );
  }

  return (
    <>
      <FormLineLayout label="Gender" isRequired>
        <Form.Item name={['invoicingContact', 'gender']} rules={RULES}>
          <Select placeholder="Select gender">
            <Option value={ADYEN_GENDER_INVOICING.MALE}>Mr</Option>
            <Option value={ADYEN_GENDER_INVOICING.FEMALE}>Mrs</Option>
          </Select>
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="First Name" isRequired>
        <Form.Item name={['invoicingContact', 'firstName']} rules={RULES}>
          <Input placeholder="First name" />
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Last Name" isRequired>
        <Form.Item name={['invoicingContact', 'lastName']} rules={RULES}>
          <Input placeholder="Last name" />
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Email" isRequired>
        <Form.Item
          name={['invoicingContact', 'email']}
          rules={[
            ...RULES,
            { type: 'email', message: 'Please enter a valid email address' },
            emailAsciiRule,
          ]}
        >
          <Input placeholder="Contact email" />
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
